import { useEffect, useState } from 'react';
import { api } from '../api.js';

// Loads one job. `status` is 'loading' | 'ok' | 'missing' | 'error'.
export function useJob(id) {
  const [state, setState] = useState({ status: 'loading', job: null });
  useEffect(() => {
    let live = true;
    api.get(`/api/jobs/${id}`)
      .then((r) => live && setState({ status: 'ok', job: r.job }))
      .catch((e) => live && setState({ status: e.status === 404 ? 'missing' : 'error', job: null }));
    return () => { live = false; };
  }, [id]);
  return state;
}
